const BadgeCard = ( { ...props }:Props ) => {

    return (
        <div className="w-60 bg-gray-100 flex px-2 py-4 items-center rounded-md">
            <div className="w-11">
                { props.icon }
            </div>
            <div className="flex flex-col ml-2 text-sm">
                <span className="font-semibold text-md">
                    { props.name }
                </span>
                {props.description}
            </div>
        </div>
    )
}

interface Props {
    name: string,
    description: string,
    icon: JSX.Element
}
export default BadgeCard
